export function DateFormat(fmt) {
    this.format = fmt;
    this.formatDate = formatDate;
    this.formatTime = formatTime;
    this.formatDateTime = formatDateTime;
}

function formatDate(d) {
    var result = this.format;
    var tokens = this.format.split(/[ \/,-]+/, 4);

    for (var i=0; i<tokens.length; i++) {
        if (tokens[i] == 'MM')
            result = result.replace(/MM/, getNumWithLeadingZero(d.getMonth() + 1));
        else if (tokens[i] == 'MMM')
            result = result.replace(/MMM/, Date.monthNamesShort[d.getMonth()]);
        else if (tokens[i] == 'MMMM')
            result = result.replace(/MMMM/, Date.monthNames[d.getMonth()]);
        else if (tokens[i] == 'dd')
            result = result.replace(/dd/, getNumWithLeadingZero(d.getDate()));
        else if (tokens[i] == 'yy')
            result = result.replace(/yy/, getShortYear(d.getFullYear()));
        else if (tokens[i] == 'yyyy')
            result = result.replace(/yyyy/, d.getFullYear());
        else if (tokens[i] == 'EEE')
            result = result.replace(/EEE/, Date.dayNamesShort[d.getDay()]);
        else if (tokens[i] == 'EEEE')
            result = result.replace(/EEEE/, Date.dayNames[d.getDay()]);
    }

    return result;
}

export function formatTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes;
    return strTime;
}

function formatDateTime(date) {
    return this.formatDate(date) + ", " + this.formatTime(date);
}


function getNumWithLeadingZero(num) {
    if (num < 10) return new String('0' + num);
    return num;
}

function getShortYear(year) {
    return new String(year).substring(2, 4);
}



// WEBPACK FOOTER //
// ./web/js/date_format.js